import gql from "graphql-tag";

export default gql`
  mutation addSourceToDeployment($deploymentId: ID, $customerId: ID, $sourceId: ID) {
    addSourceToDeployment(deploymentId: $deploymentId, customerId: $customerId, sourceId: $sourceId) {
      id
      description
    }
  }
`;
